// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorText {
  right: 38px;
  color: red;
  position: absolute;
  top: 270px;
  font-size: 0.68rem;
}

.bank-error {
  top: 259px !important;
}

@media only screen and (max-width: 768px) {
  .errorText {
    color: red;
    position: absolute;
    top: 762px;
    font-size: 0.65rem;
  }
  .bank-error {
    top: 727px !important;
  }
}
@media only screen and (max-width: 1336) {
  .errorText {
    color: red;
    position: absolute;
    top: 200px;
    font-size: 0.52rem;
  }
}
.editBtn:hover {
  color: #fff;
  border-color: #598bff;
  background-color: #598bff;
}

.editBtn {
  position: relative;
  background-color: #fff;
  color: #598bff;
  border-color: #598bff;
  box-shadow: none;
  min-height: 34px;
  width: 12%;
  border-radius: 5px;
}

.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  position: relative;
  background-color: #fff;
  color: #598bff;
  border-color: #598bff;
  box-shadow: none;
  min-height: 34px;
  width: 12%;
  border-radius: 5px;
}

.confirmAccNumerrorText .errorIcon {
  position: absolute;
  top: 45%;
  left: 0;
  font-size: 0.821rem;
  font-weight: 600;
  transform: translateY(-50%);
  color: #ff3d71;
  font-style: normal;
}

.fgError .confirmAccNumerrorText {
  padding: 7px 16px 5px;
  color: #ff3d71;
  font-size: 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-payment/agent-payment.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AACA;EACE;IACE,UAAA;IACA,kBAAA;IACA,UAAA;IACA,kBAAA;EAEF;EACA;IACE,qBAAA;EACF;AACF;AAEA;EACE;IACE,UAAA;IACA,kBAAA;IACA,UAAA;IACA,kBAAA;EAAF;AACF;AAGA;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AADF;;AAIA;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AADF;;AAIA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;AADF;;AAIA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AADF","sourcesContent":[".errorText {\r\n  right: 38px;\r\n  color: red;\r\n  position: absolute;\r\n  top: 270px;\r\n  font-size: 0.68rem;\r\n}\r\n\r\n.bank-error {\r\n  top: 259px !important;\r\n}\r\n@media only screen and (max-width: 768px) {\r\n  .errorText {\r\n    color: red;\r\n    position: absolute;\r\n    top: 762px;\r\n    font-size: 0.65rem;\r\n  }\r\n\r\n  .bank-error {\r\n    top: 727px !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 1336) {\r\n  .errorText {\r\n    color: red;\r\n    position: absolute;\r\n    top: 200px;\r\n    font-size: 0.52rem;\r\n  }\r\n}\r\n\r\n.editBtn:hover {\r\n  color: #fff;\r\n  border-color: #598bff;\r\n  background-color: #598bff;\r\n}\r\n\r\n.editBtn {\r\n  position: relative;\r\n  background-color: #fff;\r\n  color: #598bff;\r\n  border-color: #598bff;\r\n  box-shadow: none;\r\n  min-height: 34px;\r\n  width: 12%;\r\n  border-radius: 5px;\r\n}\r\n\r\n.disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  position: relative;\r\n  background-color: #fff;\r\n  color: #598bff;\r\n  border-color: #598bff;\r\n  box-shadow: none;\r\n  min-height: 34px;\r\n  width: 12%;\r\n  border-radius: 5px;\r\n}\r\n\r\n.confirmAccNumerrorText .errorIcon {\r\n  position: absolute;\r\n  top: 45%;\r\n  left: 0;\r\n  font-size: 0.821rem;\r\n  font-weight: 600;\r\n  transform: translateY(-50%);\r\n  color: #ff3d71;\r\n  font-style: normal;\r\n}\r\n\r\n.fgError .confirmAccNumerrorText {\r\n  padding: 7px 16px 5px;\r\n  color: #ff3d71;\r\n  font-size: 0.75rem;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
